module.exports = __webpack_public_path__ + "img/hkzc.4f088b37.jpg";